if (!window.Eurus.loadedScript.has('truncate-text.js')) {
  window.Eurus.loadedScript.add('truncate-text.js');
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => { 
      Alpine.data('xTruncateText', () => ({
        truncateEl: "",
        truncateInnerEl: "",
        truncated: false,
        truncatable: false,
        label: "",
        expanded: false,
        accordionMobile: false,
        accordionDesktop: false,
        isDesktop: true,
        init() {
          this.accordionMobile = this.$el.dataset.accordionMobile === 'true';
          this.accordionDesktop = this.$el.dataset.accordionDesktop === 'true';
          this.updateViewport();
          this._onViewportChange = () => this.updateViewport();
          window.addEventListener('resize', this._onViewportChange, { passive: true });
        },
        updateViewport() {
          this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        },
        usesAccordion() {
          return this.isDesktop ? this.accordionDesktop : this.accordionMobile;
        },
        get showReadMoreLink() {
          return this.truncatable && !this.usesAccordion();
        },
        get showAccordionCollapsed() {
          return this.truncatable && this.usesAccordion() && !this.expanded;
        },
        get showAccordionExpanded() {
          return this.truncatable && this.usesAccordion() && this.expanded;
        },
        load(truncateEl) {
          const truncateRect = truncateEl.getBoundingClientRect();
          truncateEl.style.setProperty("--truncate-height", `${truncateRect.height}px`);
        },
        isTruncatable(element) {
          const inner = element.querySelector('.truncate-inner');
          if (!inner) return false;

          if (inner.scrollHeight > element.clientHeight + 1
            || inner.scrollWidth > element.clientWidth + 1) {
            return true;
          }

          const clamp = window.getComputedStyle(inner).webkitLineClamp;
          if (!clamp || clamp === 'none') return false;

          const probe = inner.cloneNode(true);
          probe.setAttribute('aria-hidden', 'true');
          probe.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;display:block;-webkit-line-clamp:unset;max-height:none;overflow:visible;width:' + inner.clientWidth + 'px';
          document.body.appendChild(probe);
          const fullHeight = probe.scrollHeight;
          probe.remove();

          return fullHeight > inner.clientHeight + 1;
        },
        setTruncate(element, skipDelays = false) {
          const checkOverflow = () => {
            if (this.isTruncatable(element)) {
              this.truncated = true;
              this.truncatable = true;
              if (!element.classList.contains('truncate-expanded')) {
                this.expanded = false;
              }
            } else {
              this.truncated = false;
              this.truncatable = false;
              this.expanded = true;
            }
          };

          checkOverflow();

          if (skipDelays) return;

          requestAnimationFrame(checkOverflow);
          window.setTimeout(checkOverflow, 150);
          window.setTimeout(checkOverflow, 600);
        },
        bindResize(element) {
          if (element.dataset.truncateResizeBound === 'true') return;
          element.dataset.truncateResizeBound = 'true';

          let resizeTimer;
          let lastWidth = element.clientWidth;
          const recheck = () => {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(() => {
              this.updateViewport();
              const width = element.clientWidth;
              if (width === lastWidth) return;
              lastWidth = width;
              if (!this.expanded) {
                this.setTruncate(element, true);
                this.load(element);
              }
            }, 150);
          };

          window.addEventListener('resize', recheck, { passive: true });
        },
        open(el, newLabel) {
          const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
          this.expanded = true;
          this.label = newLabel;
          if (truncateEl.classList.contains('truncate-expanded')) {
            this.truncated = true;
          } else {
            const truncateInnerEl = truncateEl.querySelector('.truncate-inner');
            window.requestAnimationFrame(() => {
              truncateEl.classList.add('truncate-expanded');
              const fullHeight = truncateInnerEl.scrollHeight;
              truncateEl.style.setProperty("--truncate-height-expanded", `${fullHeight}px`);
            });
            this.truncated = false;
          }
        },
        close(el, newLabel, isQuickview = false) {
          this.label = newLabel;
          const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
          const isInViewport = () => {
            const rect = truncateEl.getBoundingClientRect();
            return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.xViewport.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.xViewport.innerWidth || document.documentElement.clientWidth))
          }
          this.truncated = true;
          if (!isInViewport() && !isQuickview) {
            const scrollPosition = truncateEl.getBoundingClientRect().top + window.scrollY - 500 ;
            window.scrollTo({
              top: scrollPosition,
              behavior: 'smooth'
          });
          truncateEl.style.transition = 'none'
            setTimeout(() => {
              truncateEl.style.transition = ''
            }, 1000)
          }
          truncateEl.classList.remove('truncate-expanded');
          this.expanded = false;
        }
      }));
    })
  })
}
